import { Box, Typography, Container, Grid, IconButton } from "@mui/material";
import { Facebook, Instagram, YouTube, Email, Phone, WhatsApp } from "@mui/icons-material";

function Footer() {
    return (
        <Box
            component="footer"
            sx={{
                width: "100vw",
                bgcolor: "primary.main",
                color: "primary.contrastText",
                py: 3,
                mt: "auto",
            }}
        >
            <Container maxWidth="xl">
                <Grid container spacing={3} alignItems="center">
                    {/* Left - All Rights Reserved */}
                    <Grid item xs={12} sm={4} sx={{ textAlign: { xs: "center", sm: "left" }, mb: { xs: 2, sm: 0 } }}>
                        <Typography variant="body2">
                            © {new Date().getFullYear()} BNB Cleaning Team. All rights reserved.
                        </Typography>
                    </Grid>

                    {/* Center - Social Media */}
                    <Grid item xs={12} sm={4} sx={{ textAlign: "center", mb: { xs: 2, sm: 0 } }}>
                        <IconButton href="https://www.instagram.com" target="_blank" color="inherit">
                            <Instagram />
                        </IconButton>
                        <IconButton href="https://www.facebook.com" target="_blank" color="inherit">
                            <Facebook />
                        </IconButton>
                        <IconButton href="https://www.youtube.com" target="_blank" color="inherit">
                            <YouTube />
                        </IconButton>
                    </Grid>

                    {/* Right - Contact Info */}
                    <Grid item xs={12} sm={4} sx={{ textAlign: { xs: "center", sm: "right" } }}>
                        <Box display="flex" alignItems="center" justifyContent={{ xs: "center", sm: "flex-end" }} mb={1}>
                            <Email sx={{ mr: 1 }} />
                            <Typography variant="body2">{process.env.REACT_APP_EMAIL}</Typography>
                        </Box>
                        <Box display="flex" alignItems="center" justifyContent={{ xs: "center", sm: "flex-end" }}>
                            <Phone sx={{ mr: 1 }} />
                            <WhatsApp sx={{ mr: 1 }} />
                            <Typography variant="body2">+1 (437) 688-4752</Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}

export default Footer;
